import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import {
  Button,
  Card,
  Container,
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import { getSingleManager } from "store/actions/additionalEarningAction";
import { getSeasonalManagerEarning } from "store/actions/managerAction";
import { getGroupChatManagerEarning } from "store/actions/managerAction";
import { getMomentoManagerEarning } from "store/actions/managerAction";
import { getTalkingManagerEarning } from "store/actions/managerAction";
import { getTotalEarningsByModule } from "store/actions/managerAction";

const ManagerEarning = () => {
  let dispatch = useDispatch();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("talking");
  const [loader, setLoader] = useState({
    data: false,
    loadMore: false,
  });
  const { SingleManager } = useSelector((state) => state.earnings);
  const {
    managerTotalEarnings,
    // *****talking*******
    talkingEarnings,
    talkingLastDocument,
    talkingHasMoreDocument,
    // *******seasonal******
    seasonalEarnings,
    seasonalLastDocument,
    seasonalHasMoreDocument,
    // *********momento********
    momentoEarnings,
    momentoLastDocument,
    momentoHasMoreDocument,
    // ********group chat******
    groupChatEarnings,
    groupChatLastDocument,
    groupChatHasMoreDocument,
  } = useSelector((state) => state.manager);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(getTotalEarningsByModule(id));
    dispatch(
      getTalkingManagerEarning(id, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getSingleManager(id, () => {
        setActiveTab("license");
      })
    );
  }, []);
  const [loadMoreBtn, setLoadMoreBtn] = useState(false);
  const talkingLoadMore = () => {
    setLoadMoreBtn(true);
    dispatch(
      getTalkingManagerEarning(id, talkingLastDocument, () => {
        setLoadMoreBtn(false);
      })
    );
  };
  const seasonalLoadMore = () => {
    setLoadMoreBtn(true);
    dispatch(
      getSeasonalManagerEarning(id, seasonalLastDocument, () => {
        setLoadMoreBtn(false);
      })
    );
  };
  const momentoLoadMore = () => {
    setLoadMoreBtn(true);
    dispatch(
      getMomentoManagerEarning(id, momentoLastDocument, () => {
        setLoadMoreBtn(false);
      })
    );
  };
  const groupChatLoadMore = () => {
    setLoadMoreBtn(true);
    dispatch(
      getGroupChatManagerEarning(id, groupChatLastDocument, () => {
        setLoadMoreBtn(false);
      })
    );
  };

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Card className="pb-2">
          <Nav
            tabs
            className="d-flex justify-content-start text-dark athlete_earning-nav"
          >
            <NavItem>
              <NavLink
                className={
                  activeTab === "talking"
                    ? "active active-tab py-2 "
                    : "text-dark cursor-pointer py-2 "
                }
                onClick={() => {
                  toggleTab("talking");
                  setLoader((prev) => ({
                    ...prev,
                    data: true,
                  }));
                  dispatch(
                    getTalkingManagerEarning(id, "", () => {
                      setLoader((prev) => ({
                        ...prev,
                        data: false,
                      }));
                    })
                  );
                }}
              >
                <h2 className={activeTab === "talking" ? "text-white" : ""}>
                  Talking badges
                </h2>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  activeTab === "seasonal"
                    ? "active active-tab py-2"
                    : "text-dark cursor-pointer py-2"
                }
                onClick={() => {
                  toggleTab("seasonal");
                  setLoader((prev) => ({
                    ...prev,
                    data: true,
                  }));
                  dispatch(
                    getSeasonalManagerEarning(id, "", () => {
                      setLoader((prev) => ({
                        ...prev,
                        data: false,
                      }));
                    })
                  );
                }}
              >
                <h2 className={activeTab === "seasonal" ? "text-white" : ""}>
                  Seasonal badges
                </h2>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  activeTab === "momento"
                    ? "active active-tab py-2"
                    : "text-dark cursor-pointer py-2"
                }
                onClick={() => {
                  toggleTab("momento");
                  setLoader((prev) => ({
                    ...prev,
                    data: true,
                  }));
                  dispatch(
                    getMomentoManagerEarning(id, "", () => {
                      setLoader((prev) => ({
                        ...prev,
                        data: false,
                      }));
                    })
                  );
                }}
              >
                <h2 className={activeTab === "momento" ? "text-white" : ""}>
                  Momento
                </h2>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  activeTab === "group-chat"
                    ? "active active-tab py-2"
                    : "text-dark cursor-pointer py-2"
                }
                onClick={() => {
                  toggleTab("group-chat");
                  setLoader((prev) => ({
                    ...prev,
                    data: true,
                  }));
                  dispatch(
                    getGroupChatManagerEarning(id, "", () => {
                      setLoader((prev) => ({
                        ...prev,
                        data: false,
                      }));
                    })
                  );
                }}
              >
                <h2 className={activeTab === "group-chat" ? "text-white" : ""}>
                  Group Chat
                </h2>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent
            activeTab={activeTab}
            className="p-3 athlete-earning-content"
          >
            <TabPane tabId="talking">
              <h1 className="earning-title text-center text-sm-left">
                Total Talking Earning :{" "}
                {managerTotalEarnings?.talkingEarnings
                  ? managerTotalEarnings?.talkingEarnings.toFixed(2)
                  : "0.00"}
                ${" "}
              </h1>
              {loader.data ? (
                <div className="text-center mt-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <Card className="p-2">
                  <Table
                    className="align-items-center table-flush mt-3"
                    responsive
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete Name
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete email
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete Id
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Amount
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {talkingEarnings.length > 0 ? (
                        talkingEarnings.map((items, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {items.athlete.first_name +
                                  " " +
                                  items.athlete.last_name}
                              </td>
                              <td>{items.athlete.email}</td>
                              <td>{items.athlete.athleteID}</td>
                              <td>{items.manager_payout.payout_amount}$</td>
                              <td>
                                {moment
                                  .unix(items.created_at.seconds)
                                  .format("DD MMM YYYY")}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {talkingEarnings.length > 4 && (
                    <div className="text-center py-4">
                      <Button
                        color="primary"
                        onClick={talkingLoadMore}
                        disabled={!talkingHasMoreDocument}
                      >
                        {loadMoreBtn ? <Spinner size="sm" /> : "Load More"}{" "}
                      </Button>
                    </div>
                  )}
                </Card>
              )}
            </TabPane>
            <TabPane tabId="seasonal">
              <h1 className="earning-title text-center text-sm-left">
                Total Seasonal Earning : $
                {managerTotalEarnings?.seasonalEarnings
                  ? managerTotalEarnings?.seasonalEarnings.toFixed(2)
                  : "0.00"}{" "}
              </h1>
              {loader.data ? (
                <div className="text-center mt-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <Card className="p-2">
                  <Table
                    className="align-items-center table-flush mt-3"
                    responsive
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete Name
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete email
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete Id
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Amount
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {seasonalEarnings.length > 0 ? (
                        seasonalEarnings.map((items, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {items.athlete.first_name +
                                  " " +
                                  items.athlete.last_name}
                              </td>
                              <td>{items.athlete.email}</td>
                              <td>{items.athlete.athleteID}</td>
                              <td>{items.manager_payout.payout_amount}$</td>
                              <td>
                                {moment
                                  .unix(items.createdAt.seconds)
                                  .format("DD MMM YYYY")}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {seasonalEarnings.length > 4 && (
                    <div className="text-center py-4">
                      <Button
                        color="primary"
                        onClick={seasonalLoadMore}
                        disabled={!seasonalLastDocument}
                      >
                        {loadMoreBtn ? <Spinner size="sm" /> : "Load More"}{" "}
                      </Button>
                    </div>
                  )}
                </Card>
              )}
            </TabPane>
            <TabPane tabId="momento">
              <h1 className="earning-title text-center text-sm-left">
                Total Momento Earning : $
                {managerTotalEarnings?.momentosEarnings
                  ? managerTotalEarnings?.momentosEarnings.toFixed(2)
                  : "0.00"}{" "}
              </h1>
              {loader.data ? (
                <div className="text-center mt-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <Card className="p-2">
                  <Table
                    className="align-items-center table-flush mt-3"
                    responsive
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete Name
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete email
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete Id
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Amount
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {momentoEarnings.length > 0 ? (
                        momentoEarnings.map((items, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {items.athlete.first_name +
                                  " " +
                                  items.athlete.last_name}
                              </td>
                              <td>{items.athlete.email}</td>
                              <td>{items.athlete.athleteID}</td>
                              <td>{items.manager_payout.payout_amount}$</td>
                              <td>
                                {moment
                                  .unix(items.createdAt.seconds)
                                  .format("DD MMM YYYY")}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {momentoEarnings.length > 4 && (
                    <div className="text-center py-4">
                      <Button
                        color="primary"
                        onClick={momentoLoadMore}
                        disabled={!momentoLastDocument || loadMoreBtn}
                      >
                        {loadMoreBtn ? <Spinner size="sm" /> : "Load More"}{" "}
                      </Button>
                    </div>
                  )}
                </Card>
              )}
            </TabPane>
            <TabPane tabId="group-chat">
              <h1 className="earning-title text-center text-sm-left">
                Total Group Chat Earning : $
                {managerTotalEarnings?.groupChatEarnings
                  ? managerTotalEarnings?.groupChatEarnings.toFixed(2)
                  : "0.00"}{" "}
              </h1>
              {loader.data ? (
                <div className="text-center mt-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <Card className="p-2">
                  <Table
                    className="align-items-center table-flush mt-3"
                    responsive
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete Name
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete email
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Athlete Id
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Amount
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupChatEarnings.length > 0 ? (
                        groupChatEarnings.map((items, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {items.athlete.first_name +
                                  " " +
                                  items.athlete.last_name}
                              </td>
                              <td>{items.athlete.email}</td>
                              <td>{items.athlete.athleteID}</td>
                              <td>{items.manager_payout.payout_amount}$</td>
                              <td>
                                {moment
                                  .unix(items.created_at.seconds)
                                  .format("DD MMM YYYY")}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {groupChatEarnings.length > 4 && (
                    <div className="text-center py-4">
                      <Button
                        color="primary"
                        onClick={groupChatLoadMore}
                        disabled={!groupChatLastDocument || loadMoreBtn}
                      >
                        {loadMoreBtn ? <Spinner size="sm" /> : "Load More"}{" "}
                      </Button>
                    </div>
                  )}
                </Card>
              )}
            </TabPane>
          </TabContent>
        </Card>
      </Container>
    </>
  );
};

export default ManagerEarning;
